import React, {useState} from 'react'
import { Editor } from '@tinymce/tinymce-react';
import './App.css';
import'bootstrap/dist/css/bootstrap.min.css';
import ReactDiffViewer from 'react-diff-viewer';

function App() {

// To show react-diff-viewer
 const [toggle, settoggle] = useState(false);

//  Initial value given to editor
 const [initialValue] = useState(`<p>This is the initial content of the editor.</p>`);

//  New value which we gonna add into editor
 const [Value, setValue] = useState('');

// function to set new value
 const handleEditorChange = (e) => {
  //  console.log("value changed", e.level.content);
  setValue(e.level.content.replace( /(<([^>]+)>)/ig, ''))
 }



  return (
    <div className="container">
      <Editor
        apiKey="316c8myuxuzlzc91yu01inf1y1v5ze7t1ymeangwik6eacc9"
        initialValue={initialValue}
        init={{
          width: 1200,
          height: 800,
          setup: (editor) => {
            editor.ui.registry.addButton("myCustomToolbarButton", {
              text: "DIFF-VIEWER",
              onAction: () =>  settoggle(true)
            });
          },
          menubar: 'file view insert tools format edit ',
          plugins: 'lists link code preview casechange charmap image media wordcount anchor fullscreen autolink autoresize autosave bbcode codesample directionality emoticons fullpage help hr image imagetools importcss insertdatetime legacyoutput nonbreaking noneditable pagebreak paste print quickbars searchreplace spellchecker tabfocus template textpattern toc visualblocks visualchars' ,
          toolbar1: 'formatselect | bold italic blockquote underline strikethrough | bullist numlist outdent indent | alignleft aligncenter alignright alignjustify | link code | undo redo',
          toolbar2: 'backcolor forecolor casechange | charmap | image media | preview | fullscreen | anchor | autolink | autoresize | restoredraft | codesample | ltr rtl | emoticons | fullpage | hr | paste pastetext | insertdatetime | nonbreaking | pagebreak | print | quickimage| quicktable | searchreplace | spellchecker | template | toc | visualblocks | visualchars| myCustomToolbarButton | help ',
          // skin: 'oxide-dark',

        }}
        onChange={handleEditorChange}
      >
      </Editor>

    {/* onclick Custom button  it will show React-diffviewer  */}
      {
        (toggle === true) ?
            <div className="container">
                <ReactDiffViewer oldValue={initialValue.replace( /(<([^>]+)>)/ig, '')} newValue={Value}  splitView={true} />
            </div>
        : ''
      }
    </div>
  );
}
export default App;


